import React from 'react';
import LookbookHeader from '@fuww/library/src/Lookbook/Header';
import LookbookGallery from '../../components/Lookbook/Gallery';
import Head from '../../components/Head';
import withApollo from '../../lib/apollo';
import redirectRouteToDomain from '../../lib/redirectRouteToDomain';

const Index = () => (
  <>
    <Head
      title="Worldwide Fashion Design Lookbook"
      description="Share, Create, Inspire and Showcase design on the international network for fashion professionals. Upload your design here."
    />
    <LookbookHeader
      title="Global Fashion Image Library"
      subtitle={`Share, Create, Inspire and Showcase
design on the network for fashion. Upload your design here.`}
    />
    <LookbookGallery
      withUploader
    />
  </>
);

Index.getInitialProps = redirectRouteToDomain('lookbook');

export const LookbookWithoutApollo = Index;

export default withApollo(LookbookWithoutApollo);
